'use client'
import {
  SEO_QUERY
} from "./chunk-J54FE6N4.mjs";
import {
  PAGE_SECTION_QUERY
} from "./chunk-5XBG57UU.mjs";
import {
  BUTTON_QUERY
} from "./chunk-OYEMYN5L.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  __async,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/config/config.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var getWebsiteConfig = (props) => __async(void 0, null, function* () {
  var _a, _b, _c;
  try {
    const res = yield gqlClient.request(
      gql`
        query getConfig($lang: String, $limit: Int, $where: ConfigFilter) {
          configCollection(locale: $lang, limit: $limit, where: $where) {
            items {
              title
              logo {${IMAGE_QUERY}}
              seo {${SEO_QUERY}}
              header {
                navigationCollection {
                  items {${BUTTON_QUERY}}
                }
                subNavigationCollection {
                  items {${BUTTON_QUERY}}
                }
              }
              footer {
                downloadAppPrompt
                mobileAppLinksCollection{
                  items {${BUTTON_QUERY}}
                }
                navigationCollection{
                  items {${BUTTON_QUERY}}
                }
                visitCity {${PAGE_SECTION_QUERY}}
                copyrightText
              }
              socialLinks {
                iconsCollection {
                   items {${BUTTON_QUERY}}
                }
              }
            }
          }
        }
      `,
      __spreadValues({
        limit: 1
      }, props)
    );
    if (!((_a = res == null ? void 0 : res.configCollection) == null ? void 0 : _a.items.length)) {
      throw new Error("No web config found");
    }
    return (_c = (_b = res == null ? void 0 : res.configCollection) == null ? void 0 : _b.items) == null ? void 0 : _c[0];
  } catch (error) {
    throw new Exception({ error });
  }
});
var useWebsiteConfig = (props) => {
  return useQuery({
    queryKey: ["config", props],
    queryFn: () => getWebsiteConfig(props)
  });
};

export {
  useWebsiteConfig
};
//# sourceMappingURL=chunk-WYH7GL2G.mjs.map